import { Button, DialogActions, Typography } from '@material-ui/core';
import { useIntl, FormattedMessage } from 'react-intl';

import {
  fetchSection,
  getSectionForManager,
  sendCredentialApplicationToEnsemble,
} from 'api';
import messages from 'messages';
import { useCallback, useEffect, useState } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useParams } from 'react-router-dom';
import { MANAGERIN_LAHETTAMA_TUNNUSTILAUS } from '../../Form/FormTypes.js';
import { SnackbarVariant } from '../../../constants.js';
import { useSnackbar } from 'notistack';

export default function ApplicationManagerConfirmationForm({
  handleClose,
  updateListCallback,
  applicant,
  applicantTitle,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const intl = useIntl();
  const formType = MANAGERIN_LAHETTAMA_TUNNUSTILAUS;

  const [sectionName, setSectionName] = useState();
  const [organizationName, setOrganizationName] = useState();

  const { keycloak } = useKeycloak();
  const { sectionId } = useParams();
  const hasOrganizationAdminRole =
    keycloak.hasResourceRole('organizationAdmin');

  const getSection = useCallback(() => {
    const fetchSectionMethod = hasOrganizationAdminRole
      ? fetchSection
      : getSectionForManager;

    fetchSectionMethod(sectionId).then((response) => {
      setSectionName(response.data.sectionName);
      setOrganizationName(response.data.organizationName);
    });
  }, [sectionId, hasOrganizationAdminRole]);

  useEffect(() => {
    getSection();
  }, [getSection]);

  const ssn = applicant.socialSecurityNumber;
  const applicantDates =
    applicant.validityPeriodStartDate +
    ' - ' +
    applicant.validityPeriodExpiryDate;

  const handleOnSubmit = (e) => {
    e.preventDefault();
    sendCredentialApplicationToEnsemble(applicant, formType)
      .then(() => {
        enqueueSnackbar(intl.formatMessage(messages.general_send_success), {
          variant: SnackbarVariant.SUCCESS,
        });
        updateListCallback();
        handleClose();
      })
      .catch((error) => {
        if (error.response) {
          enqueueSnackbar(intl.formatMessage(messages.general_send_error), {
            variant: SnackbarVariant.ERROR,
          });
        }
      });
  };

  return (
    <>
      <div style={{ textAlign: 'center', paddingBottom: '2rem' }}>
        <h1>{intl.formatMessage(messages.send_application)}</h1>
        <form>
          <Typography variant="subtitle1">{`Henkilötunnus: ${ssn}`}</Typography>
          <Typography variant="subtitle1">{`Organisaation: ${organizationName}`}</Typography>
          <Typography variant="subtitle1">{`Osa-alue: ${sectionName}`}</Typography>
          <Typography variant="subtitle1">{`Nimike: ${applicantTitle}`}</Typography>
          <Typography variant="subtitle1">{`Tunnustilauksen voimassaoloaika: ${applicantDates}`}</Typography>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {intl.formatMessage(messages.back)}
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={handleOnSubmit}
            >
              <FormattedMessage defaultMessage="Lähetä" />
            </Button>
          </DialogActions>
        </form>
      </div>
    </>
  );
}
